import { DRAG_DATA_KEY_EXPORT } from './taskDraggable';

export default function taskDropTarget() {
  return {
    restrict: 'A',
    scope: {
      column: '@taskDropTarget',
      onDrop: '&',
    },
    link(scope, element) {
      element.on('dragover', (event) => {
        event.preventDefault();
        event.originalEvent.dataTransfer.dropEffect = 'move';
      });

      element.on('drop', (event) => {
        event.preventDefault();
        const payloadStr = event.originalEvent.dataTransfer.getData(DRAG_DATA_KEY_EXPORT);
        if (!payloadStr) return;

        let payload;
        try {
          payload = JSON.parse(payloadStr);
        } catch {
          return;
        }

        const toColumn = Number(scope.column);
        const { taskId, fromColumn } = payload;

        if (toColumn === fromColumn) return;

        scope.onDrop({ taskId, fromColumn, toColumn });
      });
    },
  };
}
